import { DataFrame } from '../DataFrame';
import { DataPoint } from '../DataPoint';
import { DataSeries } from '../DataSeries';

export const fields = ['foo', 'bar'];
export const columns = [
    [1, 2, 3],
    ['a', 'b', 'c'],
];
export const mixedTypeDataSources = {
    data: {
        fields: [{ name: 'foo' }],
        columns: [[1, 2, 'a']],
    },
};
export const validGeoJson = {
    type: 'MultiPolygon',
    coordinates: [[[[1, 0]]]],
};
const dataPoints1 = [
    new DataPoint('foo', { value: 1, type: 'number' }),
    new DataPoint('foo', { value: 2, type: 'number' }),
    new DataPoint('foo', { value: 3, type: 'number' }),
];
const dataPoints2 = [
    new DataPoint('bar', { type: 'string', value: 'a' }),
    new DataPoint('bar', { type: 'string', value: 'b' }),
    new DataPoint('bar', { type: 'string', value: 'c' }),
];
const dataPoints3 = [
    new DataPoint('bar', { value: 87, type: 'number' }),
    new DataPoint('bar', { value: 400, type: 'number' }),
    new DataPoint('bar', { value: 135, type: 'number' }),
];
const dataPoints4 = [
    new DataPoint('bar', { value: 87, type: 'number' }),
    new DataPoint('bar', { value: 400, type: 'number' }),
    new DataPoint('bar', { value: 135, type: 'number' }),
    new DataPoint('bar', { value: 178, type: 'number' }),
];
const dataPoints5 = [
    new DataPoint('bar', { value: 87, type: 'number' }),
    new DataPoint('bar', { value: 400, type: 'number' }),
    new DataPoint('bar', { value: 135, type: 'number' }),
    new DataPoint('bar', { value: 178, type: 'number' }),
    new DataPoint('bar', { value: 200, type: 'number' }),
];
const dataPoints6 = [
    new DataPoint('bar', { value: 87, type: 'number' }),
    new DataPoint('bar', { value: 400, type: 'number' }),
];
const dataPoints7 = [new DataPoint('bar', { value: 87, type: 'number' })];
const dataPoints8 = [
    new DataPoint('foo', { type: 'null', value: null }),
    new DataPoint('foo', { value: 1, type: 'number' }),
    new DataPoint('foo', { value: 2, type: 'number' }),
    new DataPoint('foo', { value: 3, type: 'number' }),
];
const dataPoints9 = [new DataPoint('foo', { value: validGeoJson, type: 'geojson' })];
const colorTypeDataPoints = [
    new DataPoint('bar', { value: '#FF0000', type: 'color' }),
    new DataPoint('bar', { value: '#0000FF', type: 'color' }),
];
const timeTypeDataPoints = [
    new DataPoint('_time', { value: '2020-01-01', type: 'time' }),
    new DataPoint('_time', { value: '2020-01-02', type: 'time' }),
];
const internalFieldDataPoints = [
    new DataPoint('_raw', { value: 'a', type: 'string' }),
    new DataPoint('_raw', { value: 'b', type: 'string' }),
];
const mixedTypeDataPoints = [
    new DataPoint('foo', { value: 1, type: 'number' }),
    new DataPoint('foo', { value: 2, type: 'number' }),
    new DataPoint('foo', { value: 'a', type: 'string' }),
];
const sparklineTypeDataPoints = [
    new DataPoint('foo', {
        value: ['##__SPARKLINE__##', 1, 2],
        type: 'sparkline',
    }),
    new DataPoint('foo', {
        value: ['##__SPARKLINE__##', 4, 9],
        type: 'sparkline',
    }),
    new DataPoint('foo', {
        value: ['##__SPARKLINE__##', 8, 1],
        type: 'sparkline',
    }),
];

const dataSeries1 = new DataSeries(dataPoints1);
const dataSeries2 = new DataSeries(dataPoints2);
const dataSeries3 = new DataSeries(dataPoints3);
const dataSeries6 = new DataSeries(dataPoints6);
const dataSeries7 = new DataSeries(dataPoints8);
const colorTypeDataSeries = new DataSeries(colorTypeDataPoints);
const timeTypeDataSeries = new DataSeries(timeTypeDataPoints);
const mixedTypeDataSeries = new DataSeries(mixedTypeDataPoints);
const sparklineTypeDataSeries = new DataSeries(sparklineTypeDataPoints);
const internalFieldDataSeries = new DataSeries(internalFieldDataPoints);

const dataFrame = new DataFrame([dataSeries1, dataSeries2]);
// Dataframe including a dataseries (dataSeries7) with initial null point
const dataFrame2 = new DataFrame([dataSeries1, dataSeries7]);
const mixedTypeDataFrame1 = new DataFrame([mixedTypeDataSeries]);
const mixedTypeDataFrame2 = new DataFrame([timeTypeDataSeries, dataSeries6]);
const mixedTypeDataFrameWithInternalFields = new DataFrame([
    timeTypeDataSeries,
    dataSeries6,
    internalFieldDataSeries,
]);

export const data = {
    fields,
    columns,
    mixedTypeDataSources,
    dataPoints1,
    dataPoints2,
    dataPoints4,
    dataPoints5,
    dataPoints6,
    dataPoints7,
    dataPoints9,
    dataSeries1,
    dataSeries2,
    dataSeries3,
    dataSeries6,
    dataSeries7,
    colorTypeDataSeries,
    timeTypeDataSeries,
    sparklineTypeDataSeries,
    mixedTypeDataSeries,
    internalFieldDataSeries,
    dataFrame,
    dataFrame2,
    mixedTypeDataFrame1,
    mixedTypeDataFrame2,
    mixedTypeDataFrameWithInternalFields,
};

export const dataSources = { primary: { data: { fields, columns } } };
